import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [];
  initialize() {
    this.setupRecurring();
  }
  setupRecurring() {
    var check = this.element.querySelector("#recurring");
    if (check) {
      check.addEventListener("change", (event) => {
        this.toggleRecurringPanel(event.target.checked);
      });
    }
    
    // Handle contribution subscription frequency
    var contributionFrequency = this.element.querySelector(
      "#contribution_subscription_attributes_frequency"
    );
    if (contributionFrequency) {
      contributionFrequency.addEventListener("change", (event) => {
        this.showSelectedFrequencySelector(event.target.value);
      });
      this.showSelectedFrequencySelector(contributionFrequency.value);
    }
    
    // Handle grant request subscription frequency - try different possible IDs
    var grantRequestFrequency = this.element.querySelector(
      "select[name='grant_request[grant_request_subscription_attributes][frequency]']"
    ) || this.element.querySelector(
      "#grant_request_grant_request_subscription_attributes_frequency"
    ) || this.element.querySelector(
      "[name*='grant_request_subscription'][name*='frequency']"
    ) || this.element.querySelector(
      "select[name*='frequency']"
    ) || this.element.querySelector(
      "select[name*='grant_request_subscription'][name*='frequency']"
    );
    
    if (grantRequestFrequency) {
      grantRequestFrequency.addEventListener("change", (event) => {
        this.showSelectedFrequencySelector(event.target.value);
      });
      this.showSelectedFrequencySelector(grantRequestFrequency.value);
    }
  }
  toggleRecurringPanel(visible) {
    var panel = this.element.querySelector("#recurring-panel");
    if (panel) {
      this.toggle(panel, visible);
    }
  }
  toggle(el, visible) {
    if (el) {
      if (visible) {
        el.classList.remove("hidden");
      } else {
        el.classList.add("hidden");
      }
    }
  }
  showSelectedFrequencySelector(selected) {
    let month;
    let week;
    
    // Check if this is a grant request subscription (only supports monthly, quarterly, annually)
    var grantRequestFrequency = this.element.querySelector(
      "select[name='grant_request[grant_request_subscription_attributes][frequency]']"
    ) || this.element.querySelector(
      "#grant_request_grant_request_subscription_attributes_frequency"
    ) || this.element.querySelector(
      "[name*='grant_request_subscription'][name*='frequency']"
    ) || this.element.querySelector(
      "select[name*='frequency']"
    ) || this.element.querySelector(
      "select[name*='grant_request_subscription'][name*='frequency']"
    );
    
    if (grantRequestFrequency) {
      // Grant request subscriptions now always use last day of period - no day selector needed
      month = false;
      week = false;
    } else {
      // Regular contribution subscriptions support all frequencies
      switch (selected) {
        case "monthly":
          month = true;
          week = false;
          break;
        case "biweekly":
        case "weekly":
          month = false;
          week = true;
          break;
        default:
          month = false;
          week = false;
      }
    }
    
    var monthSelector = this.element.querySelector("#frequency-month-selector");
    var weekSelector = this.element.querySelector("#frequency-week-selector");
    
    if (monthSelector) {
      this.toggle(monthSelector, month);
    }
    
    // Only look for week selector if this is a contribution subscription (not grant request)
    if (!grantRequestFrequency && weekSelector) {
      this.toggle(weekSelector, week);
    }
  }
}
